<template>
    <img src="/images/promo/hero-section/technologist.png"
     alt="Technologist" />
</template>

<script>
export default {};
</script>
